import * as dateFiltersSetters from './../../scripts/modules/store/date-filters-setters'

// helper plugin that allows to fire mutation in date-filter module when mutation in filter module is fired
const dateFilterPlugin = store => {
  // called when the store is initialized
  store.subscribe((mutation, state) => {
    // called after every mutation
    if (mutation.type === 'SET_FILTER_PARAMS_RES') {
      // fires mutation in date-filter store module
      dateFiltersSetters.setDateRangeFromRes(mutation.payload)
     }
  })
}

export default dateFilterPlugin



// WEBPACK FOOTER //
// ./src/store/plugins/date-filters.js